export default {

    getReadableDuration(duration) {
        if (!duration || typeof duration !== 'string' || !duration.trim()) {
            return null;
        }

        let durationArr = duration.trim().split(/\s+/);
        if (durationArr.length < 2) {
            return null;
        }

        if (durationArr[0] == 1){
            durationArr[1] = durationArr[1].slice(0, durationArr[1].length - 1);
        }
        durationArr[1] = durationArr[1].toLowerCase();
        return durationArr;
    }
    
}
